<div *ngIf="description">
  <strong>{{ description }}</strong>
</div>
<div>
  <a mat-stroked-button (click)="openInWeb()" class="web-button">
    <ng-container *ngIf="!isLoading()">
      {{ 'INBOX.SETTINGS.MANAGE_ON_WEB' | translate }}
    </ng-container>
    <mat-spinner *ngIf="isLoading()" diameter="20"></mat-spinner>
  </a>
</div>
